import { render, staticRenderFns } from "./HoldTicketTable.vue?vue&type=template&id=4d549059&scoped=true&"
import script from "./HoldTicketTable.vue?vue&type=script&lang=ts&"
export * from "./HoldTicketTable.vue?vue&type=script&lang=ts&"
import style0 from "./HoldTicketTable.vue?vue&type=style&index=0&id=4d549059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d549059",
  null
  
)

export default component.exports